import React,{useState,useEffect,useCallback}from'react';
import Layout from'../components/layout/Layout';
import {useTranslation} from 'react-i18next';

const INP=({value,onChange,type='text',placeholder='',disabled=false}:any)=>(<input type={type} value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#015CA6] disabled:bg-gray-50"/>);
const SEL=({value,onChange,children}:any)=>(<select value={value} onChange={onChange} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none">{children}</select>);
const FLD=({label,children,required}:any)=>(<div><label className="block text-xs font-semibold text-gray-600 mb-1">{label}{required&&<span className="text-red-500 ml-0.5">*</span>}</label>{children}</div>);
const token=()=>localStorage.getItem('accessToken')||localStorage.getItem('token')||'';
const hdr=()=>({'Content-Type':'application/json','Authorization':`Bearer ${token()}`});
const BASE=process.env.REACT_APP_API_URL;


const DEF={branchName:'',branchCode:'',branchType:'MAIN',address:'',city:'',state:'',pinCode:'',phone:'',email:'',gstin:'',rohiniCode:'',nabledCode:'',nabh:'false',isActive:true,licenseNumber:'',openTime:'08:00',closeTime:'20:00',emergencyAvailable:'true',bedCount:'',icuBedCount:''};

export default function BranchManagementPage(){
  const {t}=useTranslation();
  const [loading,setLoading]=useState(true);
  const [branches,setBranches]=useState<any[]>([]);
  const [sel,setSel]=useState<any>(null);
  const [tab,setTab]=useState<'list'|'form'|'settings'|'workstations'|'number_series'|'holidays'|'weekoffs'>('list');
  const [form,setForm]=useState({...DEF});
  const [editId,setEditId]=useState<string|null>(null);
  const [msg,setMsg]=useState('');
  const [workstations,setWorkstations]=useState<any[]>([]);
  const [wf,setWf]=useState({stationName:'',stationType:'RECEPTION',branchId:''});
  const [numberSeries,setNumberSeries]=useState<any[]>([]);
  const [holidays,setHolidays]=useState<any[]>([]);
  const [hf,setHf]=useState({holidayName:'',holidayDate:'',holidayType:'NATIONAL'});
  const [weekoffs,setWeekoffs]=useState<string[]>([]);
  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),3000);};
  const f=(k:string,v:any)=>setForm(x=>({...x,[k]:v}));

  const load=useCallback(async()=>{
    setLoading(true);
    const bData=await fetch(`${BASE}/settings/branches`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]);
    setBranches(Array.isArray(bData)?bData:Array.isArray(bData?.data)?bData.data:[]);
    setLoading(false);
  },[]);

  useEffect(()=>{load();},[load]);

  const loadBranchDetails=async(branchId:string)=>{
    const [ws,ns,h]=await Promise.all([
      fetch(`${BASE}/settings/workstations?branchId=${branchId}`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/settings/number-series?branchId=${branchId}`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/settings/holidays?branchId=${branchId}`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
    ]);
    setWorkstations(Array.isArray(ws)?ws:ws?.data||[]);
    setNumberSeries(Array.isArray(ns)?ns:ns?.data||[]);
    setHolidays(Array.isArray(h)?h:h?.data||[]);
  };

  const saveBranch=async()=>{
    if(!form.branchName||!form.branchCode)return notify('❌ Name and code required');
    const payload={branchName:form.branchName,branchCode:form.branchCode.toUpperCase(),branchType:form.branchType,address:form.address,city:form.city,state:form.state,pinCode:form.pinCode,phone:form.phone,email:form.email,gstin:form.gstin||null,rohiniCode:form.rohiniCode||null,nabledCode:form.nabledCode||null,nabh:form.nabh==='true',isActive:form.isActive,licenseNumber:form.licenseNumber||null,openTime:form.openTime,closeTime:form.closeTime,emergencyAvailable:form.emergencyAvailable==='true',bedCount:form.bedCount?+form.bedCount:null,icuBedCount:form.icuBedCount?+form.icuBedCount:null};
    const url=editId?`${BASE}/settings/branches/${editId}`:`${BASE}/settings/branches`;
    const r=await fetch(url,{method:editId?'PUT':'POST',headers:hdr(),body:JSON.stringify(payload)});
    if(r.ok){notify(editId?'✅ Branch updated':'✅ Branch created');setTab('list');setEditId(null);setForm({...DEF});load();}
    else notify('❌ Failed');
  };

  const addWorkstation=async()=>{
    if(!wf.stationName||!sel)return notify('❌ Station name required');
    const r=await fetch(`${BASE}/settings/workstations`,{method:'POST',headers:hdr(),body:JSON.stringify({...wf,branchId:sel.id})});
    if(r.ok){notify('✅ Workstation added');setWf({stationName:'',stationType:'RECEPTION',branchId:''});loadBranchDetails(sel.id);}
    else notify('❌ Failed');
  };

  const addHoliday=async()=>{
    if(!hf.holidayName||!hf.holidayDate||!sel)return notify('❌ Holiday name and date required');
    const r=await fetch(`${BASE}/settings/holidays`,{method:'POST',headers:hdr(),body:JSON.stringify({...hf,branchId:sel.id})});
    if(r.ok){notify('✅ Holiday added');setHf({holidayName:'',holidayDate:'',holidayType:'NATIONAL'});loadBranchDetails(sel.id);}
    else notify('❌ Failed');
  };

  const saveWeekoffs=async()=>{
    const r=await fetch(`${BASE}/settings/branches/${sel.id}`,{method:'PUT',headers:hdr(),body:JSON.stringify({weekoffs})});
    if(r.ok)notify('✅ Week-offs saved');else notify('❌ Failed');
  };

  const DAYS=['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY','SUNDAY'];
  const NS_MODULES=['PATIENT','IPD','OPD','LAB','RADIOLOGY','BILLING','PHARMACY','BLOOD_BANK','OT','EMERGENCY','INVOICE','RECEIPT'];

  return(
    <Layout title="Branch & Location Management" actions={
      <div className="flex gap-2">
        {tab!=='form'&&<button onClick={()=>{setEditId(null);setForm({...DEF});setTab('form');}} className="px-4 py-1.5 rounded-lg text-sm font-semibold text-white" style={{background:'#02357A'}}>+ Add Branch</button>}
        {['holidays','weekoffs','number_series'].includes(tab)&&<button onClick={()=>setTab('settings')} className="px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50">← Settings</button>}
        {tab==='settings'&&sel&&<button onClick={()=>setTab('list')} className="px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50">← Back</button>}
        {tab==='form'&&<button onClick={()=>setTab('list')} className="px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50">← Back</button>}
        {tab==='workstations'&&sel&&<button onClick={()=>setTab('list')} className="px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50">← Back</button>}
      </div>
    }>
      <div className="p-4">
        {msg&&<div className={`mb-4 p-3 rounded-xl text-sm font-medium border ${msg.startsWith('✅')?'bg-green-50 border-green-200 text-green-700':'bg-red-50 border-red-200 text-red-700'}`}>{msg}</div>}

        {/* ── LIST ── */}
        {tab==='list'&&(
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
              {[['Total Branches',branches.length,'#02357A'],['Active',branches.filter((b:any)=>b.is_active!==false).length,'#039089'],['With Emergency',branches.filter((b:any)=>b.emergency_available||b.emergencyAvailable).length,'#dc2626'],['NABH Accredited',branches.filter((b:any)=>b.nabh).length,'#7c3aed']].map(([l,v,c])=>(
                <div key={l as string} className="bg-white rounded-xl border p-4" style={{borderLeft:`4px solid ${c}`}}>
                  <p className="text-xs font-semibold text-gray-500 uppercase">{l}</p>
                  <p className="text-2xl font-bold mt-1" style={{color:c as string}}>{v}</p>
                </div>
              ))}
            </div>
            {branches.length===0&&(
              <div className="text-center py-16 bg-white rounded-2xl border">
                <p className="text-5xl mb-3">🏥</p>
                <p className="text-xl font-bold text-gray-700">No branches configured</p>
                <p className="text-gray-400 text-sm mt-2 mb-5">Add your hospital branches / locations</p>
                <button onClick={()=>setTab('form')} className="px-6 py-2.5 rounded-xl text-white font-semibold" style={{background:'#02357A'}}>+ Add First Branch</button>
              </div>
            )}
            <div className="grid grid-cols-2 gap-4">
              {branches.map((b:any)=>(
                <div key={b.id} className="bg-white rounded-xl border shadow-sm p-5">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <p className="font-bold text-gray-900 text-lg">{b.branch_name||b.branchName}</p>
                      <p className="text-xs font-mono text-gray-400 mt-0.5">{b.branch_code||b.branchCode} · {b.branch_type||b.branchType}</p>
                    </div>
                    <div className="flex gap-1.5">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${b.is_active!==false?'bg-green-100 text-green-700':'bg-gray-100 text-gray-500'}`}>{b.is_active!==false?'Active':'Inactive'}</span>
                      {b.nabh&&<span className="px-2 py-0.5 rounded-full text-xs font-bold bg-purple-100 text-purple-700">NABH</span>}
                    </div>
                  </div>
                  <div className="text-xs text-gray-500 space-y-1 mb-4">
                    {(b.address||b.city)&&<p>📍 {[b.address,b.city,b.state,b.pin_code||b.pinCode].filter(Boolean).join(', ')}</p>}
                    {b.phone&&<p>📞 {b.phone}</p>}
                    {b.email&&<p>📧 {b.email}</p>}
                    {b.gstin&&<p>🏛️ KRA PIN: {b.gstin}</p>}
                    {(b.bed_count||b.bedCount)&&<p>🛏️ {b.bed_count||b.bedCount} beds{(b.icu_bed_count||b.icuBedCount)?` (ICU: ${b.icu_bed_count||b.icuBedCount})`:''}</p>}
                  </div>
                  <div className="flex gap-2">
                    <button onClick={()=>{setSel(b);setTab('settings');loadBranchDetails(b.id);}} className="flex-1 py-1.5 rounded-lg text-xs font-semibold bg-blue-50 text-[#02357A] hover:bg-blue-100">⚙️ Settings</button>
                    <button onClick={()=>{setSel(b);setTab('workstations');loadBranchDetails(b.id);}} className="flex-1 py-1.5 rounded-lg text-xs font-semibold bg-teal-50 text-[#039089] hover:bg-teal-100">🖥️ Workstations</button>
                    <button onClick={()=>{setEditId(b.id);setForm({branchName:b.branch_name||b.branchName||'',branchCode:b.branch_code||b.branchCode||'',branchType:b.branch_type||b.branchType||'MAIN',address:b.address||'',city:b.city||'',state:b.state||'',pinCode:b.pin_code||b.pinCode||'',phone:b.phone||'',email:b.email||'',gstin:b.gstin||'',rohiniCode:b.rohini_code||b.rohiniCode||'',nabledCode:b.nabled_code||b.nabledCode||'',nabh:String(b.nabh||false),isActive:b.is_active!==false,licenseNumber:b.license_number||b.licenseNumber||'',openTime:b.open_time||b.openTime||'08:00',closeTime:b.close_time||b.closeTime||'20:00',emergencyAvailable:String(b.emergency_available||b.emergencyAvailable||false),bedCount:String(b.bed_count||b.bedCount||''),icuBedCount:String(b.icu_bed_count||b.icuBedCount||'')});setTab('form');}} className="px-3 py-1.5 rounded-lg text-xs bg-gray-50 hover:bg-gray-100">✏️</button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* ── ADD/EDIT FORM ── */}
        {tab==='form'&&(
          <div className="max-w-3xl mx-auto bg-white rounded-2xl border shadow-sm overflow-hidden">
            <div className="px-6 py-4" style={{background:'linear-gradient(135deg,#02357A,#015CA6)'}}>
              <h2 className="font-bold text-white text-lg">{editId?'Edit Branch':'Add New Branch / Location'}</h2>
            </div>
            <div className="p-6 space-y-5">
              <div>
                <h3 className="font-semibold text-gray-700 mb-3 text-sm border-b pb-2">Basic Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <FLD label="Branch Name" required><INP value={form.branchName} onChange={(e:any)=>f('branchName',e.target.value)} placeholder="Main Campus"/></FLD>
                  <FLD label="Branch Code" required><INP value={form.branchCode} onChange={(e:any)=>f('branchCode',e.target.value.toUpperCase())} placeholder="MAIN-HQ"/></FLD>
                  <FLD label="Branch Type"><SEL value={form.branchType} onChange={(e:any)=>f('branchType',e.target.value)}>{['MAIN','OPD','LAB','PHARMACY','SATELLITE','CAMP','DAYCARE'].map(t=><option key={t}>{t}</option>)}</SEL></FLD>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700 mb-3 text-sm border-b pb-2">Contact & Address</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="col-span-3"><FLD label="Address"><INP value={form.address} onChange={(e:any)=>f('address',e.target.value)} placeholder="Street, Area"/></FLD></div>
                  <FLD label="City"><INP value={form.city} onChange={(e:any)=>f('city',e.target.value)} placeholder="Nairobi"/></FLD>
                  <FLD label="County"><INP value={form.state} onChange={(e:any)=>f('state',e.target.value)} placeholder="Nairobi County"/></FLD>
                  <FLD label="Postal Code"><INP value={form.pinCode} onChange={(e:any)=>f('pinCode',e.target.value)} placeholder="00100"/></FLD>
                  <FLD label="Phone"><INP value={form.phone} onChange={(e:any)=>f('phone',e.target.value)} placeholder="07XX-XXXXXX"/></FLD>
                  <FLD label="Email"><INP type="email" value={form.email} onChange={(e:any)=>f('email',e.target.value)} placeholder="branch@hospital.com"/></FLD>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700 mb-3 text-sm border-b pb-2">Legal & Regulatory</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <FLD label="KRA PIN"><INP value={form.gstin} onChange={(e:any)=>f('gstin',e.target.value.toUpperCase())} placeholder="P051234567X"/></FLD>
                  <FLD label="MOH Facility Code"><INP value={form.rohiniCode} onChange={(e:any)=>f('rohiniCode',e.target.value)} placeholder="MOH facility code"/></FLD>
                  <FLD label="KENAS Accreditation"><INP value={form.nabledCode} onChange={(e:any)=>f('nabledCode',e.target.value)} placeholder="KENAS accreditation no."/></FLD>
                  <FLD label="License Number"><INP value={form.licenseNumber} onChange={(e:any)=>f('licenseNumber',e.target.value)} placeholder="Health dept license"/></FLD>
                  <FLD label="NABH Accredited"><SEL value={form.nabh} onChange={(e:any)=>f('nabh',e.target.value)}><option value="false">{t('common.no','No')}</option><option value="true">{t('common.yes','Yes')}</option></SEL></FLD>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700 mb-3 text-sm border-b pb-2">Operations</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <FLD label="Opening Time"><INP type="time" value={form.openTime} onChange={(e:any)=>f('openTime',e.target.value)}/></FLD>
                  <FLD label="Closing Time"><INP type="time" value={form.closeTime} onChange={(e:any)=>f('closeTime',e.target.value)}/></FLD>
                  <FLD label="Emergency Available"><SEL value={form.emergencyAvailable} onChange={(e:any)=>f('emergencyAvailable',e.target.value)}><option value="false">{t('common.no','No')}</option><option value="true">Yes — 24x7</option></SEL></FLD>
                  <FLD label="Total Beds"><INP type="number" value={form.bedCount} onChange={(e:any)=>f('bedCount',e.target.value)} placeholder="100"/></FLD>
                  <FLD label="ICU Beds"><INP type="number" value={form.icuBedCount} onChange={(e:any)=>f('icuBedCount',e.target.value)} placeholder="10"/></FLD>
                  <div className="flex items-center gap-2 pt-5"><input type="checkbox" checked={form.isActive} onChange={e=>f('isActive',e.target.checked)} className="w-4 h-4 rounded"/><label className="text-sm font-medium">Active Branch</label></div>
                </div>
              </div>
              <div className="flex gap-3 pt-2">
                <button onClick={()=>{setTab('list');setEditId(null);setForm({...DEF});}} className="flex-1 py-2.5 border rounded-xl text-gray-600 text-sm">{t('common.cancel','Cancel')}</button>
                <button onClick={saveBranch} className="flex-1 py-2.5 rounded-xl text-white font-semibold text-sm" style={{background:'#02357A'}}>{editId?'Update Branch':'Create Branch'}</button>
              </div>
            </div>
          </div>
        )}

        {/* ── WORKSTATIONS ── */}
        {tab==='workstations'&&sel&&(
          <div>
            <h2 className="font-bold text-gray-800 text-lg mb-4">Workstations — {sel.branch_name||sel.branchName}</h2>
            <div className="grid grid-cols-3 gap-5">
              <div className="bg-white rounded-xl border shadow-sm p-5">
                <h3 className="font-bold mb-4 text-gray-700">Add Workstation</h3>
                <div className="space-y-3">
                  <FLD label="Station Name" required><INP value={wf.stationName} onChange={(e:any)=>setWf(x=>({...x,stationName:e.target.value}))} placeholder="Reception 1, Lab Counter"/></FLD>
                  <FLD label="Station Type"><SEL value={wf.stationType} onChange={(e:any)=>setWf(x=>({...x,stationType:e.target.value}))}>
                    {['RECEPTION','BILLING','PHARMACY','LAB','RADIOLOGY','NURSING','DOCTOR','ADMIN','OT','BLOOD_BANK','EMERGENCY'].map(t=><option key={t}>{t}</option>)}
                  </SEL></FLD>
                  <button onClick={addWorkstation} className="w-full py-2.5 rounded-xl text-white font-semibold text-sm" style={{background:'#02357A'}}>+ Add Station</button>
                </div>
              </div>
              <div className="col-span-2 bg-white rounded-xl border overflow-hidden">
                <div className="overflow-x-auto"><table className="w-full text-sm">
                  <thead><tr style={{background:'#02357A'}}>{['Station Name','Type','Actions'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-bold text-white">{h}</th>)}</tr></thead>
                  <tbody className="divide-y">
                    {workstations.length===0&&<tr><td colSpan={3} className="text-center py-8 text-gray-400">No workstations yet</td></tr>}
                    {workstations.map((w:any,i:number)=>(
                      <tr key={w.id} className={i%2===0?'':'bg-gray-50/50'}>
                        <td className="px-4 py-3 font-semibold">{w.station_name||w.stationName}</td>
                        <td className="px-4 py-3"><span className="px-2 py-0.5 bg-blue-50 text-[#02357A] rounded text-xs font-bold">{w.station_type||w.stationType}</span></td>
                        <td className="px-4 py-3"><button onClick={async()=>{if(!window.confirm('Delete?'))return;await fetch(`${BASE}/settings/workstations/${w.id}`,{method:'DELETE',headers:hdr()});notify('✅ Deleted');loadBranchDetails(sel.id);}} className="px-2 py-1 rounded text-xs bg-red-50 text-red-500">🗑️</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
</div>
              </div>
            </div>
          </div>
        )}

        {/* ── BRANCH SETTINGS ── */}
        {tab==='settings'&&sel&&(
          <div>
            <h2 className="font-bold text-gray-800 text-lg mb-4">Settings — {sel.branch_name||sel.branchName}</h2>
            <div className="flex gap-1 mb-5 bg-gray-100 p-1 rounded-xl w-fit">
              {[['holidays','🎉 Holidays'],['weekoffs','📅 Week-offs'],['number_series','🔢 Number Series']].map(([t,l])=>(
                <button key={t} onClick={()=>{setTab(t as any);}} className="px-4 py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-white hover:shadow hover:text-[#02357A] transition-all">{l}</button>
              ))}
            </div>
          </div>
        )}

        {/* Settings sub-tab header */}
        {['holidays','weekoffs','number_series'].includes(tab)&&sel&&(
          <div className="mb-4">
            <h2 className="font-bold text-gray-800 text-lg">Settings — {sel.branch_name||sel.branchName}</h2>
            <div className="flex gap-1 mt-3 bg-gray-100 p-1 rounded-xl w-fit">
              {[['holidays','🎉 Holidays'],['weekoffs','📅 Week-offs'],['number_series','🔢 Number Series']].map(([t,l])=>(
                <button key={t} onClick={()=>setTab(t as any)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${tab===t?'bg-white text-[#02357A] shadow font-semibold':'text-gray-600 hover:text-gray-800'}`}>{l}</button>
              ))}
            </div>
          </div>
        )}

        {/* ── HOLIDAYS ── */}
        {tab==='holidays'&&sel&&(
          <div className="grid grid-cols-3 gap-5">
            <div className="bg-white rounded-xl border shadow-sm p-5">
              <h3 className="font-bold mb-4 text-gray-700">Add Holiday</h3>
              <div className="space-y-3">
                <FLD label="Holiday Name" required><INP value={hf.holidayName} onChange={(e:any)=>setHf(x=>({...x,holidayName:e.target.value}))} placeholder="Republic Day"/></FLD>
                <FLD label="Date" required><INP type="date" value={hf.holidayDate} onChange={(e:any)=>setHf(x=>({...x,holidayDate:e.target.value}))}/></FLD>
                <FLD label="Type"><SEL value={hf.holidayType} onChange={(e:any)=>setHf(x=>({...x,holidayType:e.target.value}))}>{['NATIONAL','REGIONAL','OPTIONAL','RESTRICTED','BRANCH_SPECIFIC'].map(t=><option key={t}>{t}</option>)}</SEL></FLD>
                <button onClick={addHoliday} className="w-full py-2.5 rounded-xl text-white font-semibold text-sm" style={{background:'#02357A'}}>+ Add Holiday</button>
              </div>
            </div>
            <div className="col-span-2 bg-white rounded-xl border overflow-hidden">
              <div className="px-4 py-3 border-b font-semibold text-sm text-gray-700">Holidays — {sel.branch_name||sel.branchName}</div>
              <div className="divide-y max-h-96 overflow-y-auto">
                {holidays.length===0&&<p className="text-center py-8 text-gray-400 text-sm">No holidays added</p>}
                {holidays.map((h:any)=>(
                  <div key={h.id} className="flex items-center justify-between px-4 py-3">
                    <div><p className="font-semibold text-sm">{h.holiday_name||h.holidayName}</p><p className="text-xs text-gray-400">{h.holiday_date?.split('T')[0]||h.holidayDate} · {h.holiday_type||h.holidayType}</p></div>
                    <button onClick={async()=>{if(!window.confirm('Delete?'))return;await fetch(`${BASE}/settings/holidays/${h.id}`,{method:'DELETE',headers:hdr()});notify('✅ Deleted');loadBranchDetails(sel.id);}} className="px-2 py-1 rounded text-xs bg-red-50 text-red-500">🗑️</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ── WEEK-OFFS ── */}
        {tab==='weekoffs'&&sel&&(
          <div className="max-w-md mx-auto bg-white rounded-2xl border shadow-sm p-6">
            <h3 className="font-bold text-gray-800 mb-4">Week-off Days — {sel.branch_name||sel.branchName}</h3>
            <p className="text-sm text-gray-400 mb-4">Select days the branch is closed / half-day</p>
            <div className="space-y-2 mb-5">
              {DAYS.map(d=>(
                <label key={d} className="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-gray-50">
                  <input type="checkbox" checked={weekoffs.includes(d)} onChange={e=>{if(e.target.checked)setWeekoffs(x=>[...x,d]);else setWeekoffs(x=>x.filter(w=>w!==d));}} className="w-4 h-4 rounded"/>
                  <span className="text-sm font-medium">{d}</span>
                </label>
              ))}
            </div>
            <button onClick={saveWeekoffs} className="w-full py-2.5 rounded-xl text-white font-semibold text-sm" style={{background:'#02357A'}}>Save Week-offs</button>
          </div>
        )}

        {/* ── NUMBER SERIES ── */}
        {tab==='number_series'&&sel&&(
          <div>
            <h3 className="font-bold text-gray-800 mb-4">Number Series — {sel.branch_name||sel.branchName}</h3>
            <div className="bg-white rounded-xl border overflow-hidden">
              <table className="w-full text-sm">
                <thead><tr style={{background:'#02357A'}}>{['Module','Prefix','Start No.','Current','Padding','Format Preview'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-bold text-white">{h}</th>)}</tr></thead>
                <tbody className="divide-y">
                  {NS_MODULES.map((mod:string,i:number)=>{
                      const ns:any=numberSeries.find((n:any)=>(n.module||n.series_module)===mod)||{};
                      const defP=ns.prefix||mod.slice(0,3);
                      const defS=String(ns.starting_number||ns.startingNumber||1);
                      const defPd=String(ns.padding||6);
                      let lP=defP,lS=defS,lPd=defPd;
                      return(
                        <tr key={mod} className={i%2===0?'':'bg-gray-50/50'}>
                          <td className="px-4 py-2"><span className="px-2 py-0.5 bg-blue-50 text-[#02357A] rounded text-xs font-bold">{mod}</span></td>
                          <td className="px-4 py-2"><input defaultValue={defP} onChange={e=>{lP=e.target.value.toUpperCase();}} className="w-20 border rounded-lg px-2 py-1 text-xs focus:outline-none"/></td>
                          <td className="px-4 py-2"><input type="number" defaultValue={defS} onChange={e=>{lS=e.target.value;}} className="w-20 border rounded-lg px-2 py-1 text-xs focus:outline-none"/></td>
                          <td className="px-4 py-2 text-xs text-gray-500">{ns.current_number||ns.currentNumber||defS}</td>
                          <td className="px-4 py-2"><input type="number" defaultValue={defPd} onChange={e=>{lPd=e.target.value;}} className="w-14 border rounded-lg px-2 py-1 text-xs focus:outline-none" min={3} max={10}/></td>
                          <td className="px-4 py-2"><span className="font-mono text-xs text-[#039089] font-bold">{`${lP}-${lS.padStart(+lPd,'0')}`}</span></td>
                          <td className="px-4 py-2"><button onClick={async()=>{
                            const r2=await fetch(`${BASE}/settings/number-series`,{method:'POST',headers:hdr(),body:JSON.stringify({module:mod,prefix:lP,startingNumber:+lS,padding:+lPd,branchId:sel.id})});
                            if(r2.ok)notify('✅ Saved');else notify('❌ Failed');
                          }} className="px-3 py-1 rounded-lg text-xs font-semibold text-white" style={{background:'#039089'}}>{t('common.save','Save')}</button></td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
